<template>
<div class="chapter">
<div class="inner_page">
<a id="p1"></a>
<div class="copyright">
<p class="left ">Copyright © 1981 by Stanislaw Lem, Kraków</p>
<div class="timebreak "> </div>
<p class="left ">English translation copyright © 1984 by Harcourt Brace Jovanovich, Inc.</p>
<div class="timebreak "> </div>
<p class="left ">All rights reserved. No part of this publication may be reproduced or transmitted in any form or by any means, electronic or mechanical, including photocopy, recording, or any information storage and retrieval system, without permission in writing from the publisher.</p>
<div class="timebreak "> </div>
<p class="left ">For information about permission to reproduce selections from this book, write to <a href="mailto:trade.permissions@hmhco.com">trade.permissions@hmhco.com</a> or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.</p>
<div class="timebreak "> </div>
<p class="left "><a href="http://www.hmhco.com/popular-reading" target="_blank">www.hmhco.com</a></p>
<div class="timebreak "> </div>
<p class="left ">In accordance with the author’s wishes, this English-language edition of <em>Imaginary Magnitude</em> includes all the material that appeared in <em>Wielkość urojona</em> (Czytelnik, Warsaw, 1973) and also incorporates “Lecture XLIII—About Itself” and “Afterword,” which first appeared in <em>Golem XIV</em> (Wydawnictwo Literackie, Cracow, 1981).</p>
<div class="timebreak "> </div>
<p class="left ">Publisher’s note: Names of actual persons and entities appearing in this work of fiction are included solely for purposes of verisimilitude.</p>
<div class="timebreak "> </div>
<p class="left ">The “Proffertinc” portion of <em>Vestrand’s Extelopedia in 44 Magnetomes</em> appeared originally in <em>The New Yorker.</em></p>
<div class="timebreak "> </div>
<p class="left ">The Library of Congress has cataloged the print edition as follows:</p>
<p class="left ">Lem, Stanislaw.
<br/>
Imaginary magnitude.</p>
<p class="left ">Translation of: Wielkość urojona.<br/>
“A Helen and Kurt Wolff Book.”</p>
<p class="left ">“. . . this English-language edition also incorporates ‘Lecture XLIII—About Itself’ and ‘Afterword,’ which first appeared in Golem XIV (Wydawnictwo Literackie, Cracow, 1981)”—T. p. verso.
<br/>
I. Title.</p>
<p class="left ">PG7158.L39W513 1984 891.8'537 83-18624
<br/>
<span class="smallcaps">ISBN</span> 0-15-644180-2(pbk.)</p>
<div class="timebreak "> </div>
<p class="left ">e<span class="smallcaps">ISBN</span> 978-0-544-00308-8<br/>
v2.0616</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?247a7906